


export const reportFilterDataSource = {
  QUERY: "QUERY",
  LOCAL: "LOCAL",
};

export const reportFilterComponentTypes = {
  DROPDOWN: "DROPDOWN",
  COUNTRIES: "COUNTRIES",
  SEARCHQUERYDROPDOWN:"SEARCHQUERYDROPDOWN",
  BOOLEAN: "boolean",
};

// What a filter means by "all", travels with the report so the backend resolves the values the same way.
// ZEROFILL lists every value that exists, so one without rows still gets a bar at 0 — "orders per
// channel" has to show the channel that sold nothing. PRESENT lists only the values the data carries,
// for dimensions where the full list is meaningless: ~200 countries, or a catalog of thousands.
export const categoryAllBehaviors = {
  ZEROFILL: "zerofill",
  PRESENT: "present",
};

export const chartTypes = {
  BAR: "bar",
  LINE: 'line',
  AREA: "area",
}

export const pivotTableCategoryOptions = {
  DATERANGE:"daterange",
  COLUMN:"column"
}

export const chartDateOptions = {
  RELATIVE:'relative',
  DYNAMIC:'dynamic',
  ROLLING:'rolling',
}

export const chartRollingUnits = {
  DAY:'day',
  WEEK:'week',
  MONTH:'month',
  QUARTER:'quarter',
  YEAR:'year',
}

export const chartDateTimeFrames = {
  FIVTEENMINUTES:"15M",
  THIRTYMINUTES:"30M",
  ONEHOUR:"1H",
  FOURHOURS:"4H",
  ONEDAY:"1D",
  ONEWEEK:"1W",
}
// Day span of each rolling unit — feeds getAllowedTimeframes so the frame picker offers the right
// bucket choices per unit (e.g. week → 4H / 1D / 1W), exactly like the relative/dynamic flow does.
export const rollingUnitDays = {
  day: 1,
  week: 7,
  month: 31,
  quarter: 92,
  year: 366,
}

// Default bucket frame applied when a unit is (re)selected; the user can still refine it within the
// allowed set for that unit (day→hourly, week/month→daily, quarter/year→weekly).
export const rollingUnitToFrame = {
  day: chartDateTimeFrames.ONEHOUR,
  week: chartDateTimeFrames.ONEDAY,
  month: chartDateTimeFrames.ONEDAY,
  quarter: chartDateTimeFrames.ONEWEEK,
  year: chartDateTimeFrames.ONEWEEK,
}

export const timeframeRules = [
  { maxDays: 1,  min: chartDateTimeFrames.FIVTEENMINUTES },
  { maxDays: 2,  min: chartDateTimeFrames.THIRTYMINUTES },
  { maxDays: 3,  min: chartDateTimeFrames.ONEHOUR },
  { maxDays: 7,  min: chartDateTimeFrames.FOURHOURS },
  { maxDays: Infinity, min: chartDateTimeFrames.ONEDAY },
];

export const timeframeOrder = [
  ...Object.values(chartDateTimeFrames)
];

export const getMinimumTimeframe = (days) => {
  if (!Number.isFinite(days) || days <= 0) {
      return chartDateTimeFrames.FIVTEENMINUTES;
  }

  return timeframeRules.find(r => days <= r.maxDays).min;
};

export const getAllowedTimeframes = (days) => {
  const min = getMinimumTimeframe(days);
  const minIndex = timeframeOrder.indexOf(min);
  return timeframeOrder.slice(minIndex);
};

export const normalizeFrame = (currentFrame, days) => {
  const allowed = getAllowedTimeframes(days);
  return allowed.includes(currentFrame) ? currentFrame : allowed[0];
};
export const calculateDaysBetween = (from, to) => {
  const start = new Date(from);
  const end = new Date(to);

  const diffMs = end - start;
  return Math.max(1, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
};

export const rhChartColorsLight = [
  "#1F77B4", // Blue
  "#FF7F0E", // Orange
  "#2CA02C", // Green
  "#D62728", // Red
  "#9467BD", // Purple
  "#8C564B", // Brown
  "#E377C2", // Pink
  "#7F7F7F", // Gray
  "#BCBD22", // Olive
  "#17BECF", // Cyan

  "#003F5C", // Deep Blue
  "#58508D", // Indigo
  "#BC5090", // Magenta
  "#FF6361", // Coral Red
  "#FFA600", // Amber

  "#0D3B66", // Navy
  "#F95738", // Strong Orange
  "#1B9E77", // Teal Green
  "#D95F02", // Burnt Orange
  "#7570B3", // Violet

  "#E7298A", // Hot Pink
  "#66A61E", // Lime Green
  "#E6AB02", // Gold
  "#A6761D", // Mustard
  "#666666"  // Dark Gray
]

export const rhChartColorsDark = [
  "#4FC3F7", // Light Blue
  "#FFB74D", // Soft Orange
  "#81C784", // Light Green
  "#E57373", // Light Red
  "#BA68C8", // Light Purple
  "#bda096ff", // Warm Brown
  "#F06292", // Pink
  "#E0E0E0", // Light Gray
  "#DCE775", // Lime Yellow
  "#4DD0E1", // Cyan

  "#64B5F6", // Sky Blue
  "#FFD54F", // Yellow
  "#4DB6AC", // Teal
  "#FF8A65", // Coral
  "#9575CD", // Lavender

  "#7986CB", // Indigo
  "#AED581", // Soft Green
  "#FF7043", // Orange Red
  "#81D4FA", // Ice Blue
  "#CE93D8", // Mauve

  "#FFF176", // Bright Yellow
  "#80CBC4", // Aqua
  "#FFAB91", // Peach
  "#C5E1A5", // Light Lime
  "#B39DDB", // Soft Violet

  "#F48FB1", // Rose
  "#90CAF9", // Light Blue
  "#FFCC80", // Light Orange
  "#A5D6A7", // Mint
  "#EEEEEE"  // Near White
];